import {Component, OnInit} from '@angular/core';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserInfo, UserService } from 'src/app/data/service/user.service';

@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavRightComponent implements OnInit {
  userInfo$: Observable<UserInfo>;

  constructor(private _router: Router, private userService: UserService) {
     this.userInfo$ = this.userService.userInfo$;
   }

  ngOnInit() {
  }

  cerrarSesion(){
    this._router.navigate(['/login']);
    localStorage.clear();
  }
  
  iniciarSesion(){
    this._router.navigate(['/login']);
  }
}
